import { render, staticRenderFns } from "./AdminIconProto.vue?vue&type=template&id=5322c012&scoped=true"
import script from "./AdminIconProto.vue?vue&type=script&lang=ts"
export * from "./AdminIconProto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5322c012",
  null
  
)

export default component.exports